import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Section } from "@/components/app/Primitives";
import { MemoCard } from "@/components/engage/ClearancePayment";
import { inr } from "@/components/engage/ResultBadge";

export default function PaymentApprovals() {
  const [memos, setMemos] = useState([]);
  const load = () => api.get("/payment-memos").then((r) => setMemos(r.data));
  useEffect(() => { load(); }, []);
  const pending = memos.filter((m) => m.status === "submitted");
  return (
    <div className="space-y-6" data-testid="payment-approvals-page">
      <Section title="Payment approvals" subtitle="Payment memos built only from audit-cleared, KYS-verified creator lines. Approving hands the memo to the (simulated) HUL Procure-to-Pay interface." />
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {[["Awaiting approval", pending.length], ["Awaiting ₹", inr(pending.reduce((a, m) => a + m.total, 0))], ["In PTP", memos.filter((m) => ["sent_to_ptp", "processing"].includes(m.status)).length], ["Paid", memos.filter((m) => m.status === "paid").length]].map(([l, v]) => (
          <div key={l} className="rounded-xl border border-slate-200 bg-white p-4" data-testid={`appr-stat-${l.toLowerCase().replace(/[^a-z]/g, "")}`}><div className="text-[10px] uppercase tracking-wider text-slate-500">{l}</div><div className="font-mono text-2xl font-bold text-slate-900">{v}</div></div>
        ))}
      </div>
      <div className="space-y-3" data-testid="appr-memo-list">{memos.map((m) => <MemoCard key={m.id} memo={m} onChange={load} showCampaign />)}{memos.length === 0 && <div className="text-sm text-slate-400">No payment memos yet.</div>}</div>
    </div>
  );
}
